import { render } from "./HistoryUserPage.vue?vue&type=template&id=6ea0f91b&ts=true"
import script from "./HistoryUserPage.vue?vue&type=script&lang=ts"
export * from "./HistoryUserPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__